/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2024
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import _ from 'lodash';

import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import CustomizedMap from './CustomizedMap';
import { DecisionContainer } from '../../containers';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import fetch from '../../core/fetch/fetch.server';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import history from '../../core/history';
import loadingData from './loading';
import ModalAlert from './ModalAlert';
import { PersonalDataContainer } from '../../containers';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { runService } from '../../actions/eservices';
import utils from './utils';
import v from './validators';

import pans from './panStyle.scss';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const decisionTypeOptions = [
  {
    label: 'zgodnie z wydanym postanowieniem Prezydenta Miasta',
    value: 'postanowienie',
    state: 'decisionType',
  },
  {
    label: 'w oparciu o przepisy ustawy o gospodarce nieruchomościami* – art. 95 pkt',
    value: 'ustawa',
    state: 'decisionType',
  },
];

let InfoTypeDict = {
  registerNumber: {
    label: 'Numer księgi wieczystej:',
    editable: true,
    placeholder: 'Format numeru księgi: WL1A/00000123/1'
  },
  decisionType: {
    label: 'Podział następuje:',
    editable: true,
    type: 'Select',
    options:  decisionTypeOptions,
  },
};


class DecyzjaPodzialu extends React.Component {
  state = {
    info: {
      registerNumber: null,
      decisionType: null,
      decisionTypeSign: null,
      decisionTypeDate: null,
      decisionTypeRule: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    attachments: null,
    loading: false,
    isMounted: false,
  };

  validators = {
    registerNumber: [v.NotNull, v.CheckWieczysta],
    decisionType: [v.NotSelected],
    decisionTypeSign: [],
    decisionTypeDate: [],
    decisionTypeRule: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.state.info.decisionType == 'postanowienie') {
      this.validators.decisionTypeSign = [v.NotNull];
      this.validators.decisionTypeDate = [v.NotNull, v.CheckDate];
      this.validators.decisionTypeRule = [];
    } else {
      this.validators.decisionTypeSign = [];
      this.validators.decisionTypeDate = [];
    }

    if (this.state.info.decisionType == 'ustawa') {
      this.validators.decisionTypeRule = [v.NotNull];
      this.validators.decisionTypeSign = [];
      this.validators.decisionTypeDate = [];
    } else {
      this.validators.decisionTypeRule = [];
    }

  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name == 'decisionType') {
      const key1 = 'decisionTypeSign';
      const key2 = 'decisionTypeDate';
      const key3 = 'decisionTypeRule';

      const index = Object.keys(InfoTypeDict).indexOf('decisionType') + 1;
      if (e.value == 'postanowienie') {
        const valueDict = {
          label: 'Znak postanowienia:',
          editable: true,
        };
        const valueDict2 = {
          label: 'Data postanowienia:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key3]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key1, valueDict, index);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key2, valueDict2, index + 1);
      } else if (e.value == 'ustawa') {
        const valueDict = {
          label: 'Punkt art. 95, dla którego zachodzą w/w przesłanki:',
          editable: true,
        };
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key2]);
        InfoTypeDict = utils.insertKeyAtPosition(InfoTypeDict, key3, valueDict, index);
      }
      
      else {
        InfoTypeDict = utils.deleteKeys(InfoTypeDict, [key1, key2, key3]);
      }
    }

    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name, this.updateValidators),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <GrayPanel title={'Informacje dodatkowe'} >
          
          <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
          <p>1. Protokół z przyjęcia granic nieruchomości</p>
          <p>2. Wykaz zmian gruntowych</p>
          <p>3. Wykaz synchronizacyjny, jeżeli oznaczenie działek gruntu w katastrze nieruchomości jest inne niż w księdze wieczystej</p>
          <p>4. Mapa z projektem podziału</p>
          <p>5. Inne załączniki</p>

          <p><b>Dodatkowe załączniki do wniosku o wydanie decyzji na podstawie art. 95 ww. ustawy:</b></p>
          <p>1. Dokumenty stwierdzające tytuł prawny do nieruchomości w szczególności oświadczenie, o którym mowa w art. 116 ust. 2 pkt. 4 ww. ustawy</p>
          <p>2. Wypis z katastru nieruchomości i kopia mapy katastralnej obejmującej nieruchomość podlegającą podziałowi</p>
          <p>3. Pozwolenie na budowę w przypadku zastosowania podziału w trybie art. 95 pkt.1 ww. ustawy</p>
          <p>4. Pozwolenie, wojewódzkiego konserwatora zabytków na podział, w przypadku nieruchomości wpisanej do rejestru  zabytków</p>
          <p>5. Rzuty poszczególnych kondygnacji budynku wraz z przedstawieniem przebiegu projektowanej granicy w przypadku, gdy przedmiotem podziału jest nieruchomość zabudowana, a proponowany jej podział powoduje także podział budynku</p>
          <p>6. Opinia biegłego zgodna z §4 ust. 1 i 2 Rozporządzenia Rady Ministrów z dnia 7 grudnia 2004 r. (Dz.U. nr 268 poz. 2663), jeżeli przedmiotem podziału jest nieruchomość zabudowana a proponowany podział powoduje także podział budynku</p>
          <p>7. Zaświadczenie o przyjęciu budynku do użytkowania</p>

          <p>
            * - Ustawa z dnia 21 sierpnia 1997r. o gospodarce nieruchomościami (Dz.U. z 2023 r. poz. 344 ze zm.)
          </p>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DecyzjaPodzialu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DecyzjaPodzialu),
);



// WEBPACK FOOTER //
// src/routes/eservices/DecyzjaPodzialu.js